<template>
    <div>
    <v-card raised class="mb-4">
    <v-layout row wrap>
    <v-flex xs12 md6>
        <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
        <v-flex d-flex xs8>{{fuelItem.Facility}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.ArticleNo}} - {{fuelItem.ArticleName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
          <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.CarrierNo}} - {{fuelItem.CarrierName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(fuelItem)}}</v-flex>
        </v-layout>
    </v-flex>
    <v-flex xs12 md6>
        <v-layout v-if="!isHide('Fuel type')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Fuel type")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.WasteFuelTypeNo}} - {{fuelItem.WasteFuelTypeName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.AgreementNo}} - {{fuelItem.AgreementName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
        <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
        <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.DeliveryNo}} - {{fuelItem.DeliveryName}}</v-flex>
        </v-layout>
        <v-layout v-if="!isHide('Delivered')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
          <v-flex d-flex xs4>{{$t("Amount")}}:</v-flex>
          <v-flex d-flex xs8>{{fuelItem.Amount}}</v-flex>
        </v-layout>
    </v-flex>
    </v-layout>
    <v-flex xs12 class="mb-4">
      <v-layout row wrap>
        <v-flex grow></v-flex>
        <v-btn class="mt-1 mr-3 mb-n1" color="primary" :to="{name: 'unloading-fuel-create-registration', params: {id: fuelItem.Id, facility: fuelItem.Facility}}">{{$t('New registration')}}</v-btn>
      </v-layout>
    </v-flex>
    <v-card-actions style="padding: 0px 0px 0px 0px" v-if="fuelItem.FinishedBy == null && !fuelItem.Completed">
    </v-card-actions>
</v-card>

<v-dialog v-model="showArrivalDialog" max-width="600" @keydown.esc="showArrivalDialog = false" persistent>
    <v-card>
    <v-card-title v-if="arrivalTitleGPS" class="headline" primary-title>{{$t('GPS distance near location') + '  (' + distance + ' km)'}}</v-card-title>
    <v-card-title v-if="!arrivalTitleGPS" class="headline" primary-title>{{$t('QR-barcode scanned')}}</v-card-title>
    <v-container fluid grid-list-md >
        <v-layout row wrap>
        <v-flex xs12 md12>
            <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
            <v-flex d-flex xs8>{{fuelItem.Facility}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.CustomerName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.ArticleName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Fuel type')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Fuel type")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.WasteFuelTypeName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.AgreementName}}</v-flex>
            </v-layout>
            <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
            <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
            <v-flex d-flex xs8 style="padding-right: 6px">{{fuelItem.DeliveryName}}</v-flex>
            </v-layout>
        </v-flex>
        </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-card-actions>
        <v-container fluid grid-list-md  style="padding: 0px 0px 0px 14px">
        <v-layout row wrap>
            <v-flex xs12 md4>
            <v-flex d-flex xs12>{{$t("PreStatus3")}}</v-flex>
            </v-flex>
            <v-flex xs12 md3 align-self-center>
            <v-btn x color="error" @click="cancelArrivalAndReload">{{$t("Cancel")}}</v-btn>
            </v-flex>
            <v-flex xs12 md5 align-self-center>
            <v-btn color="success" @click="saveArrivalAndReload">{{$t("Register arrival")}}</v-btn> <!-- 4 = Arrival registered, awaiting loading -->
            </v-flex>
        </v-layout>
        </v-container>
    </v-card-actions>
    </v-card>
</v-dialog>
</div>
</template>

<script>
import * as fuelItemistration from '@/modules/unloading-fuel/unloading-fuel'
import * as Security from '@/core/security'

export default {
  components: { },
  props: ['fuelItem'],
  data () {
    return {
      showScanDialog: false,
      showArrivalDialog: false,
      arrivalTitleGPS: false,
      distance: 0,
      userVehicleLicensePlateNo: '',
      videoReady: true,
      testVideoError: false,
      isCameraLoaded: false,
      isDecoding: false,
      hiddenFields: []
    }
  },
  methods: {
    getCustomerStr (fuelItem) {
      if (fuelItem.CustomerNo && fuelItem.CustomerName) { return fuelItem.CustomerNo + ' - ' + fuelItem.CustomerName } else if (fuelItem.CustomerNo) { return fuelItem.CustomerNo } else if (fuelItem.CustomerName) { return fuelItem.CustomerName } else { return '' }
    },
    async save (val) {
      this.showArrivalDialog = false
      this.fuelItem.PreStatus = val
      const res = await fuelItemistration.saveRegistration(this.fuelItem)
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('PreStatus' + val))
        if (this.fuelItem.PreStatus === 4) location.reload() // Fix so camera gets turned off (using a lot of cpu)
      }
    },
    isHide (fieldName) {
      // console.log('hiding', this.hiddenFields.some(h => h === fieldName), fieldName)
      return this.hiddenFields.some(h => h === fieldName)
    },
    cancelArrivalAndReload () {
      this.showArrivalDialog = false
      location.reload() // Fix so camera gets turned off (using a lot of cpu)
    },
    saveArrivalAndReload () {
      this.save(4) // 4 = Change to "Arrival registered, awaiting loading"
      // location.reload() // Fix so camera gets turned off (using a lot of cpu)
    }
  },
  beforeDestroy () {
    // Unsubscribe to distance events
    this.$root.$off('distance', this.checkDistanceAndShowArrival)
  },
  async mounted () {
    // Load settings
    this.gpsAcceptedDistanceKm = Security.user.corporationDetails.find(d => d.Name === 'fuelItemistration_GPSAcceptedDistanceKm')?.Data1 ?? '0.2'

    // Open Arrival Dialog on accepted distance
    this.checkDistanceAndShowArrival = async (val) => {
      this.distance = val
      if (this.userVehicleLicensePlateNo && // only check GPS for users with a VehicleLicensePlateNo
            val <= this.gpsAcceptedDistanceKm && // GPS distance <= settings distance = Accepted Distance
            !this.showArrivalDialog && // dont reopen
            !this.showScanDialog && // not when scanning dialog open
            this.fuelItem.PreStatus === 1) { // only while waiting QR or GPS
        this.fuelItem.PreStatus = 3 // Change to "Awaiting arrival registration"
        this.save(3) // Awaiting arrival registration
        this.arrivalTitleGPS = true
        this.showArrivalDialog = true
      }
    }

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      // const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      const defaultHidden = 'RequisitionNo2,Plant,Comment'
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'fuelItemistration_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }
    // load Users VehicleLicensePlateNo - if any - and filter buttons and features off if no VehicleLicensePlateNo exist (ie. WheelLoader users).
    // const userRes = await fuelItemistration.userVehicleLicensePlateNo()
    // if (!userRes.failed) {
    //   this.userVehicleLicensePlateNo = userRes.data.userVehicleLicensePlateNo
    // }
    // Subscribe to distance change events and open Arrival Dialog on accepted distance
    this.$root.$on('distance', this.checkDistanceAndShowArrival)
  }
}
</script>
